import { observer } from 'mobx-react-lite'
import { SingleItemSelector } from '@/components/SingleItemSelector'
import { Avatar } from '@/components/Avatar'
import { FormGroupContainer } from '@/components/FormContainer'
import { FormRow } from '@/components/Form'
import { ManageSkillsDialog } from '@/features/user-management/ManageSkillsDialog'
import { type ManageSkillsDialogViewModel } from './ManageSkillsDialogViewModel'
import { SkillsSelectorContainer } from '@/features/user-management/components/SkillsSelectorContainer'

export interface ManageSkillsDialogContainerProps {
  vm: ManageSkillsDialogViewModel
}

export const ManageSkillsDialogContainer = observer(
  function ManageSkillsDialogContainer({
    vm,
  }: ManageSkillsDialogContainerProps) {
    const testId = 'manage-skills'

    return (
      <ManageSkillsDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        selectedUserName={vm.selectedUserName}
        selectedWorkspaceName={vm.selectedWorkspaceName}
        selectedTab={vm.selectedTab}
        onTabChange={vm.setSelectedTab}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        {!vm.selectedWorkspace && (
          <FormRow>
            <FormGroupContainer
              label="Workspace"
              error={vm.validation.getError('workspace')}
            >
              <SingleItemSelector
                value={vm.workspace}
                itemOptions={vm.workspaces}
                itemPrefix={(item) => (
                  <Avatar
                    subject={{
                      avatar: item?.branding.logos.icon,
                    }}
                    size={24}
                  />
                )}
                onChange={vm.setWorkspace}
                itemToString={(item) => (item ? item.name : '')}
                placeholder="Select workspace"
                isDisabled={vm.submit.pending}
                testId={`${testId}-workspace-selector`}
              />
            </FormGroupContainer>
          </FormRow>
        )}

        <FormRow>
          <FormGroupContainer
            label="Skills"
            error={vm.validation.getError('skills')}
          >
            <SkillsSelectorContainer
              vm={vm}
              isDisabled={vm.submit.pending}
              testId={`${testId}-selector`}
            />
          </FormGroupContainer>
        </FormRow>
      </ManageSkillsDialog>
    )
  },
)
